import React from "react";
import { Card } from "antd";

import PasswordResetForm from "@Components/shared/PasswordUpdateForm";

import "@Styles/components/accountSecurity.scss";

const AccountSecurityTab = () => {
    return (
        <Card title="Change password" className="account-security-tab newUI-raised">
            <PasswordResetForm type="update" />
        </Card>
    );
};

export default AccountSecurityTab;
